import '../../../style.css';

import { FieldWrapper, FormControl, View } from '@zinc/ui';
import { useId, useMemo } from 'react';
import { NumericFormat } from 'react-number-format';

export interface IProps {
  prefix?: React.ReactNode;
  postfix?: React.ReactNode;
  label?: React.ReactNode;
  scale?: number;
  onChange?: (value: string) => void;
  value?: number | string;
  className?: string;
  placeholder?: string;
  max?: number;
  min?: number;
  submitted?: boolean;
  errorText?: React.ReactNode;
  variant?: string;
  removeLegacyPadding?: boolean;
  fixedDecimalScale?: boolean;
  [key: string]: any;
}

export const FieldDecimal: React.FC<IProps> = ({
  prefix,
  postfix,
  label,
  scale = 2,
  onChange,
  value,
  className = '',
  placeholder = '0.00',
  max,
  min,
  submitted,
  errorText,
  variant = undefined,
  removeLegacyPadding = false,
  fixedDecimalScale = true,
  ...other
}) => {
  const maxValue = useMemo(() => {
    return !max ? (postfix === '%' ? 100 : undefined) : max;
  }, [max, postfix]);

  return (
    <View paddingBottom={removeLegacyPadding ? 0 : 2} className={className}>
      <FormControl hasError={submitted && !!errorText}>
        {label && <FormControl.Label>{label}</FormControl.Label>}
        <FieldWrapper
          name={useId()}
          variant={variant}
          startSlot={prefix}
          endSlot={<View justify="start">{postfix}</View>}
        >
          <NumericFormat
            type="text"
            thousandSeparator={false}
            isAllowed={createIsAllowed({ min, max: maxValue })}
            decimalScale={scale}
            fixedDecimalScale={fixedDecimalScale}
            allowNegative={false}
            placeholder={placeholder}
            value={value != null ? value.toString() : ''}
            className={`
              bg-transparent
            w-full
            text-right
            pr-0
            h-full
            !border-r-0
            !shadow-none
            !border-none
            focus:outline-none
            transition
            duration-150
            ease-in-out
            text-sm
            py-2
            mt-[-2px]
            ${className}
          `}
            onChange={(e) => {
              if (typeof onChange === 'function') {
                onChange(e.target.value);
              }
            }}
            {...other}
          />
        </FieldWrapper>
        <FormControl.Error>{errorText}</FormControl.Error>
      </FormControl>
    </View>
  );
};

export default FieldDecimal;
interface RangeProps {
  min?: number;
  max?: number;
}

export const createIsAllowed = ({ min, max }: RangeProps) => {
  return ({ floatValue }: { floatValue?: number }) => {
    // undefined or null values are allowed
    if (floatValue === undefined || floatValue === null) return true;

    if (min !== undefined && floatValue < min) return false;
    if (max !== undefined && floatValue > max) return false;

    return true;
  };
};
